import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';
import { AppShell } from '@/components/layout/AppShell';
import { AuthGuard } from '@/components/auth/AuthGuard';
import { AdminGuard } from '@/components/auth/AdminGuard';
import LoginPage from '@/pages/LoginPage';
import AuthCallbackPage from '@/pages/AuthCallbackPage';
import SettingsPage from '@/pages/SettingsPage';
import SandboxLoadingPage from '@/pages/SandboxLoadingPage';
import DownloadsPage from '@/pages/DownloadsPage';
import NotFoundPage from '@/pages/NotFoundPage';
import AdminLoginPage from '@/pages/admin/AdminLoginPage';
import AdminHomePage from '@/pages/admin/AdminHomePage';
import AdminKeysPage from '@/pages/admin/AdminKeysPage';
import AdminAdminsPage from '@/pages/admin/AdminAdminsPage';
import AdminReleasesPage from '@/pages/admin/AdminReleasesPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <AppShell>
        <Outlet />
      </AppShell>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/login" replace />,
      },
      {
        path: 'login',
        element: <LoginPage />,
      },
      {
        path: 'landing',
        element: <LoginPage />,
      },
      {
        path: 'auth/callback',
        element: <AuthCallbackPage />,
      },
      {
        path: 'settings',
        element: (
          <AuthGuard>
            <SettingsPage />
          </AuthGuard>
        ),
      },
      {
        path: 'downloads',
        element: (
          <AuthGuard>
            <DownloadsPage />
          </AuthGuard>
        ),
      },
      {
        path: 'sandbox-loading',
        element: (
          <AuthGuard>
            <SandboxLoadingPage />
          </AuthGuard>
        ),
      },
      // Admin routes
      {
        path: 'admin',
        element: (
          <AdminGuard>
            <AdminHomePage />
          </AdminGuard>
        ),
      },
      {
        path: 'admin/login',
        element: <AdminLoginPage />,
      },
      {
        path: 'admin/keys',
        element: (
          <AdminGuard>
            <AdminKeysPage />
          </AdminGuard>
        ),
      },
      {
        path: 'admin/admins',
        element: (
          <AdminGuard requireSuperAdmin>
            <AdminAdminsPage />
          </AdminGuard>
        ),
      },
      {
        path: 'admin/releases',
        element: (
          <AdminGuard>
            <AdminReleasesPage />
          </AdminGuard>
        ),
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
]);
